var _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _g, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatientsPic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 75,
    viewBox: "0 0 111 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.041 5.5979C11.041 3.94105 12.3842 2.5979 14.041 2.5979H21.0296C22.6865 2.5979 24.0296 3.94105 24.0296 5.5979V8.44278H11.041V5.5979Z",
    fill: "#DDDDED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5234 5.5979C30.5234 3.94105 31.8666 2.5979 33.5234 2.5979H43.7592C45.4161 2.5979 46.7592 3.94105 46.7592 5.5979V8.44278H30.5234V5.5979Z",
    fill: "#DDDDED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1279 0C72.2353 0 69.7118 1.26175 68.45 2.83894L65.1472 7.97872H7.25507C3.15438 7.97872 0 11.4485 0 15.2338V67.4295C0 71.5302 3.15438 74.6846 7.25507 75H103.148C107.249 75 110.403 71.5302 110.403 67.7449V20.7447L110.143 2.83894C108.882 1.26175 106.358 0 104.466 0H74.1279Z",
    fill: "#F1F1FE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M81.1777 7.79285H94.1664",
    stroke: "#6C6D8A",
    strokeWidth: 10,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M97.4141 9.74158H107.156",
    stroke: "#6C6D8A",
    strokeWidth: 15,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6837 10.3908C76.1183 10.3908 77.2814 9.22778 77.2814 7.7931C77.2814 6.35841 76.1183 5.19537 74.6837 5.19537C73.249 5.19537 72.0859 6.35841 72.0859 7.7931C72.0859 9.22778 73.249 10.3908 74.6837 10.3908Z",
    fill: "#DDDDED"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75.3336,
    cy: 44.1614,
    r: 23.9312,
    fill: "white",
    stroke: "#DDDDED",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_515_6061",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 53,
    y: 22,
    width: 44,
    height: 44
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.3336,
    cy: 44.1614,
    r: 21.4312,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_515_6061)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.2597 54.9555C80.2183 52.3623 80.2597 49.6854 80.2597 49.6854C80.2597 49.6854 83.524 49.0998 84.1438 44.7499C84.7636 40.6091 83.7306 31.7002 83.7306 31.7002C78.9787 29.818 73.6484 30.5291 70.3428 34.4189L70.8387 55.3319C70.88 57.7578 73.0286 59.64 75.5905 59.5563C78.1937 59.4727 80.2597 57.4232 80.2597 54.9555Z",
    fill: "#FFBE9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8613 39.3753C82.8613 39.668 82.6547 39.919 82.3242 39.9608C82.0349 39.9608 81.787 39.7517 81.7457 39.4589C81.7457 39.1661 81.9523 38.9152 82.2828 38.8734C82.5721 38.8734 82.82 39.0825 82.8613 39.3753Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7297 38.9573C83.6471 39.041 83.2339 38.7064 82.6554 38.7482C81.5397 38.9155 81.5811 39.0828 81.5811 38.9991C81.5397 38.9573 81.6224 38.8318 81.7877 38.7064C81.9529 38.5809 82.2835 38.4136 82.6554 38.4136C83.0273 38.4136 83.3165 38.5391 83.5231 38.6645C83.6884 38.79 83.771 38.9155 83.7297 38.9573Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7891 39.5846C76.7891 39.8774 76.5825 40.1284 76.2519 40.1702C75.9627 40.1702 75.7147 39.961 75.6734 39.6683C75.6734 39.3755 75.88 39.1245 76.2106 39.0827C76.5411 39.0409 76.7891 39.2918 76.7891 39.5846Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5735 39.1662C77.4908 39.2498 77.0776 38.9152 76.4991 38.957C75.9207 38.957 75.4661 39.2498 75.4248 39.208C75.3835 39.1662 75.4661 39.0407 75.6314 38.9152C75.7967 38.7897 76.1273 38.6224 76.4991 38.6224C76.871 38.6224 77.1603 38.7479 77.3669 38.8734C77.5321 38.9989 77.6148 39.1243 77.5735 39.1662Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.764 43.0459C79.764 43.0041 80.1359 42.9622 80.7143 42.8786C80.8796 42.8786 81.0036 42.8367 81.0449 42.7113C81.0862 42.5858 81.0036 42.4185 80.9209 42.2512C80.7557 41.8747 80.6317 41.4983 80.4664 41.0801C79.8466 39.4488 79.3508 38.0686 79.4334 38.0686C79.5161 38.0268 80.0532 39.3652 80.7143 40.9964C80.8796 41.4147 81.0036 41.7911 81.1689 42.1675C81.2102 42.3348 81.3341 42.544 81.2515 42.7531C81.2102 42.8786 81.0862 42.9622 81.0036 42.9622C80.9209 43.0041 80.8383 43.0041 80.7557 43.0041C80.1359 43.0459 79.764 43.0459 79.764 43.0459Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2598 49.6438C80.2598 49.6438 77.3674 49.8529 74.5163 48.1799C74.5163 48.1799 75.9212 51.1495 80.2184 50.6894L80.2598 49.6438Z",
    fill: "#EB996E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5906 44.7848C78.6596 44.7482 79.0281 45.3099 79.7215 45.4969C80.415 45.684 80.9571 45.295 81.0016 45.3724C81.0239 45.411 80.9304 45.5617 80.6888 45.69C80.4473 45.8183 80.0577 45.9243 79.6481 45.8389C79.2162 45.7149 78.8778 45.4402 78.7442 45.2082C78.5761 44.9945 78.5561 44.8032 78.5906 44.7848Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3327 31.5696C73.9866 33.9151 78.3389 36.3475 81.4726 36.8688C81.1244 36.391 79.2094 35.2182 78.8177 34.7404C80.2539 35.7829 82.256 37.2162 84.1275 37.3031C84.3451 37.3031 84.6063 37.3031 84.7804 37.2162C85.0415 37.0859 85.085 36.7819 85.1285 36.5213C85.2591 35.4354 85.1721 33.5242 84.998 32.4383C84.8239 31.3524 84.3016 30.2665 83.3876 29.5281C82.169 28.6159 80.4715 28.3553 78.8177 28.3119C77.4684 28.2684 76.0322 28.3553 74.8135 28.8331C73.5513 29.3109 72.5068 30.3099 72.3327 31.4393",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9592 40.6176C66.7526 39.4883 66.5873 38.4426 66.546 37.7316C66.422 35.5148 67.7801 28.1035 75.383 28.7308L75.7136 31.0731C75.7136 31.0731 76.8705 39.1037 71.9534 39.1455C71.9534 39.1455 72.5467 44.5896 69.4329 43.8719C69.4742 43.8719 67.455 43.0016 66.9592 40.6176Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9536 39.1457C71.499 39.0621 71.0032 39.0621 70.59 39.2712C70.1768 39.4385 69.7636 39.7731 69.5983 40.1914C69.433 40.6096 69.433 41.1115 69.5983 41.5716C69.7636 42.0317 70.0528 42.4081 70.3834 42.7427C70.6313 42.9937 70.8792 43.2028 71.2098 43.2865C71.5404 43.3701 71.9122 43.3283 72.1602 43.1192",
    fill: "#FFBE9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7478 41.9899C71.7891 41.9899 71.6238 42.2827 71.1693 42.199C70.9627 42.1572 70.7561 41.9899 70.6321 41.739C70.5082 41.5298 70.4255 41.2789 70.3842 40.9861C70.3429 40.6933 70.4255 40.4005 70.5495 40.1496C70.7148 39.9404 70.9214 39.7731 71.128 39.7731C71.5412 39.7731 71.7065 40.0659 71.6651 40.0659C71.6238 40.1077 71.4585 39.9404 71.1693 40.0241C70.8801 40.0659 70.6321 40.4423 70.7148 40.9443C70.7561 41.4043 70.9627 41.8644 71.2106 41.9481C71.5412 42.0736 71.7065 41.9481 71.7478 41.9899Z",
    fill: "#EB996E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4261 31.5969C71.364 32.2119 70.0744 32.3656 68.8606 32.0581C67.6469 31.7506 66.5848 30.9051 65.978 29.8289C65.5987 29.137 65.3711 28.2914 65.5228 27.5227C65.8262 26.4465 66.8124 25.7547 67.8745 25.4472C69.3917 25.0628 71.1364 25.4472 72.2744 26.5234C73.4123 27.5996 73.9433 29.3676 73.4123 30.9051C72.8812 32.4425 71.364 33.5187 69.771 33.4418",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3931 31.0316C69.4344 31.0734 69.7237 30.4042 70.3848 29.9441C71.0459 29.4422 71.707 29.3167 71.707 29.2749C71.707 29.233 70.9633 29.233 70.2608 29.7768C69.5584 30.2787 69.3105 31.0316 69.3931 31.0316Z",
    fill: "#6A6EF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2656 77.7184L57.9058 64.4362L65.0129 68.9534L60.052 77.7184C60.052 77.7184 58.4223 77.7184 52.2656 77.7184Z",
    fill: "#EB996E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1477 54.8147C66.4533 53.058 70.7093 52.5561 70.7093 52.5561C71.9489 55.0657 75.8743 55.4003 78.2296 53.6854L80.2129 52.3052C80.2129 52.3052 80.5022 52.3052 81.0393 52.347C85.7085 52.7653 89.5513 56.2786 90.5016 60.9632C90.8322 62.6362 91.1214 64.602 90.9975 66.4006C90.7495 70.9596 86.0804 71.3779 86.0804 71.3779C86.0804 71.3779 85.988 73.4925 85.6988 77.1313C83.1637 77.1313 83.9317 76.9074 81.4525 78.0367C79.6344 78.8732 81.285 77.1313 75.1962 77.1313C66.3233 77.1313 69.9449 77.1313 63.9693 77.1313C64.6717 72.7814 62.1147 71.6288 62.0321 71.3779C62.0321 71.336 62.0321 71.2942 62.0321 71.2942L57.4042 67.1116L54.7598 64.8948C54.8011 64.8948 60.5446 56.2368 63.1477 54.8147Z",
    fill: "#FFAE33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4668 68.2146C90.4255 68.2146 90.3429 67.8382 89.8884 67.5036C89.6818 67.3363 89.3512 67.2108 88.9793 67.2108C88.814 67.2108 88.6074 67.2944 88.4008 67.3363C88.1942 67.3781 87.9463 67.4199 87.6984 67.2944C87.4505 67.1689 87.3265 66.918 87.2439 66.7089C87.1612 66.4997 87.1199 66.2906 87.0373 66.1233C86.9133 65.7887 86.6241 65.5796 86.3348 65.4959C85.7977 65.3286 85.4258 65.5796 85.4258 65.5377C85.4258 65.5377 85.4671 65.4541 85.6324 65.4123C85.7977 65.3286 86.0456 65.2868 86.3348 65.3704C86.6241 65.4541 86.9959 65.6632 87.1612 66.0815C87.2439 66.2906 87.2852 66.4579 87.3678 66.667C87.4505 66.8762 87.5331 67.0435 87.6984 67.1271C88.0289 67.2944 88.4835 67.0435 88.8967 67.0435C89.3099 67.0435 89.6818 67.2108 89.8884 67.4199C90.4668 67.7963 90.5082 68.2146 90.4668 68.2146Z",
    fill: "#FAFAFA",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 76.1921,
    cy: 43.3043,
    r: 1.28587,
    fill: "#EB996E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.3047,
    y: 56.2016,
    width: 0.857249,
    height: 3.00037,
    transform: "rotate(-32.6032 67.3047 56.2016)",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.8672,
    y: 61.0582,
    width: 0.857249,
    height: 3.00037,
    transform: "rotate(-57.0094 72.8672 61.0582)",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.7754,
    y: 56.8422,
    width: 1.13049,
    height: 2.20997,
    transform: "rotate(-20.4635 76.7754 56.8422)",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.8457,
    y: 58.3557,
    width: 0.857249,
    height: 1.76925,
    transform: "rotate(-120 72.8457 58.3557)",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.0488,
    y: 62.0762,
    width: 0.857249,
    height: 1.76925,
    transform: "rotate(-120 83.0488 62.0762)",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.6738,
    y: 55.8094,
    width: 0.67105,
    height: 2.93333,
    transform: "rotate(-62.2791 81.6738 55.8094)",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.1797,
    y: 63.9778,
    width: 0.67105,
    height: 2.93333,
    transform: "rotate(-114.189 78.1797 63.9778)",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.2695,
    y: 58.9141,
    width: 0.67105,
    height: 2.93333,
    transform: "rotate(-98.8816 85.2695 58.9141)",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.6172,
    y: 58.9001,
    width: 0.67105,
    height: 2.03037,
    transform: "rotate(-62.2791 61.6172 58.9001)",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.9512,
    y: 58.6737,
    width: 0.67105,
    height: 1.81197,
    transform: "rotate(-94.0201 80.9512 58.6737)",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.0938,
    y: 62.1031,
    width: 0.67105,
    height: 1.81197,
    transform: "rotate(-94.0201 68.0938 62.1031)",
    fill: "white",
    fillOpacity: 0.4
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.024 32.1033L20.0792 32.052L36.0366 44.141C36.5238 44.4287 36.9848 44.7754 37.4092 45.1809L37.4712 45.2279L37.4644 45.2342C37.5541 45.3216 37.642 45.4117 37.7282 45.5044C40.5633 48.5551 40.3885 53.3264 37.3379 56.1615C34.2872 58.9966 29.5158 58.8218 26.6808 55.7712C26.5946 55.6784 26.5112 55.5841 26.4306 55.4883L26.4238 55.4947L26.3814 55.4293C26.0081 54.9765 25.696 54.4913 25.4448 53.9844L14.5555 37.1853L14.6107 37.134C13.695 35.6356 13.9278 33.6509 15.2639 32.4091C16.6001 31.1673 18.5965 31.0804 20.024 32.1033Z",
    fill: "#DDDDED"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1462 57.7996C36.2709 57.7996 39.6146 54.4558 39.6146 50.3311C39.6146 46.2064 36.2709 42.8627 32.1462 42.8627C28.0215 42.8627 24.6777 46.2064 24.6777 50.3311C24.6777 54.4558 28.0215 57.7996 32.1462 57.7996Z",
    fill: "#DDDDED",
    stroke: "#F1F1FE",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientsPic);
export default __webpack_public_path__ + "static/media/patientsPic.e41d8044dbb121720879e1634d2a1738.svg";
export { ForwardRef as ReactComponent };